import { BehaviorSubject } from 'rxjs';
import { handleError } from '_helpers';
import { handleResponse } from '_helpers';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
const currentUserIdSubject = new BehaviorSubject(localStorage.getItem('userName'));

export const authenticationService = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  currentUserId: currentUserIdSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
  get currentUserIdValue() {
    return currentUserIdSubject.value;
  },
  get isAuthenticated(){
    if (!currentUserSubject.value) { 
      return true;
    } else {
      return false;
    }
  }
};

function login(username, password) {
  const releaseObject = { username: username, password: password };

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(releaseObject),
  };

  return fetch(process.env.REACT_APP_DASHBOARD_API_BASE_URL + '/auth', requestOptions)
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem('currentUser', JSON.stringify(user));
      localStorage.setItem('userName', username);
      currentUserSubject.next(user);
      currentUserIdSubject.next(username);
      return user;
    })
    .catch((error) => {
      return Promise.reject(handleError(error));
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('currentUser');
  localStorage.removeItem('userName');
  currentUserIdSubject.next(null);
  currentUserSubject.next(null);
}
